import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import LoadingBar from 'react-redux-loading-bar'
import { Path } from '../constants/path'

import Header from "../components/layout/Header"
import Footer from "../components/layout/Footer"
import Meta from "../components/layout/Meta";
import Analytics from "../components/util/Analytics";
import { Alert } from "../components/util/Alert";

import RootScreen from "./RootScreen";
import FacilitiesScreen from "./FacilitiesScreen";
import FacilityScreen from "./FacilityScreen";
import MapScreen from "./MapScreen";
import NotFoundScreen from "./NotFoundScreen";


class App extends Component {

  render = () => {
    return (
      <Router>
        <div className="uk-position-relative">
          <Meta />
          <Header />
          <LoadingBar className="uk-position-fixed uk-position-z-index loading-bar" />
          <div id="main">
            <Switch>
              <Route exact path={Path.root.url} component={RootScreen} />
              <Route exact path={Path.facilities.url} component={FacilitiesScreen} />
              <Route exact path={Path.map.url} component={MapScreen} />
              <Route exact path={Path.facilities.view.url} component={FacilityScreen} />
              <Route component={NotFoundScreen} />
            </Switch>
          </div>
          <Footer/>
          <Analytics />
          <Alert ref={alert => this.alert = alert} />
        </div>
      </Router>
    );
  }
}
export default (App);
